/**
 * True when relationFlags shares any bit with flags. JavaScript's `&` truncates to 32 bits and silently drops
 * roles above bit 31, so the test is done on BigInt. A mask built with `|` is truncated the same way, so pass
 * roles at bit 31 or above on their own, never combined with `|`.
 */
export const hasRelationFlag = (relationFlags: number | null | undefined, flags: number): boolean =>
  relationFlags != null && (BigInt(relationFlags) & BigInt(flags)) !== BigInt(0);
